/** Tester review 2026-09-28 — French translation of uiStrings.v2.es.ts. */
export const V2_FR: Record<string, string> = {
  // Home
  'home.heading': 'Vous avez une question, une suggestion ou une préoccupation concernant le Projet ?',
  'home.subheading': 'Nous voulons vous écouter.',
  'home.intro': 'Voici le canal du Projet « Jubilación Segura » pour poser des questions, partager des suggestions, exprimer des préoccupations ou déposer des plaintes et réclamations liées à ses activités, impacts, bénéfices ou mise en œuvre.',
  'home.mechanism': 'Toutes les communications seront reçues et évaluées conformément au Mécanisme de prise en charge du Projet.',
  'home.privacy': 'Votre vie privée est importante pour nous. Vous pouvez présenter votre demande de manière anonyme. Si vous choisissez de fournir vos données personnelles, elles seront utilisées uniquement pour traiter votre demande et vous contacter, conformément à notre Politique de protection des données.',
  'home.start': 'Commencer ma demande',

  // Type of record
  'form.type.heading': 'Comment souhaitez-vous présenter votre demande ?',
  'form.type.identified.title': 'Je souhaite laisser mes coordonnées',
  'form.type.identified.desc': 'Vous enregistrez vos données personnelles et de contact (par exemple nom et téléphone). L’équipe du Projet pourra vous contacter pendant l’évaluation de votre demande et pour vous répondre.\nVous pourrez consulter l’état de votre demande grâce au code de suivi.',
  'form.type.anonymous.title': 'Je souhaite que ma demande reste anonyme',
  'form.type.anonymous.desc': 'Il n’est pas nécessaire d’enregistrer vos données personnelles. Votre demande sera reçue et évaluée conformément au Mécanisme de prise en charge du Projet. Sans coordonnées, nous ne pourrons ni vous contacter directement ni vous envoyer de réponse personnalisée.\nVous pourrez utiliser votre code de suivi pour consulter l’état de votre demande.',

  // Requester
  'form.requester.heading': 'Comment pouvons-nous vous contacter ?',
  'form.requester.notice': 'Ces données nous permettront de vous contacter pour suivre votre demande et vous répondre.',
  'form.requester.fullName': 'Nom et prénom / Nom de l’organisation',
  'form.requester.gender': 'Genre',
  'form.requester.gender.M': 'Homme',
  'form.requester.gender.F': 'Femme',
  'form.requester.contactPrompt': 'Comment préférez-vous être contacté(e) ?',
  'form.requester.phone': 'Téléphone / WhatsApp',
  'form.requester.phonePlaceholder': 'Ex. 999 999 999',
  'form.requester.email': 'E-mail',
  'form.requester.emailPlaceholder': 'Ex. nom@courriel.com',
  'form.requester.contactHint': 'Indiquez au moins un moyen de contact.',
  'form.requester.idHeading': 'Pièce d’identité (facultatif)',
  'form.requester.idDocumentType': 'Type de document',
  'form.requester.id.RUC': 'RUC (personne morale)',
  'form.requester.idNotice': 'Il n’est pas nécessaire de fournir votre pièce d’identité pour présenter une demande. Si vous la fournissez, elle sera utilisée uniquement pour traiter votre demande, conformément à la Politique de protection des données.',

  // Request
  'form.request.heading': 'Que souhaitez-vous communiquer au Projet ?',
  'form.request.headingHelp': 'Si vous hésitez, choisissez l’option la plus proche de votre situation.',
  'form.request.category': 'Type de demande',
  'category.CONSULTA': 'Question ou demande d’information',
  'category.SUGERENCIA': 'Suggestion ou proposition',
  'category.PREOCUPACION': 'Préoccupation ou alerte',
  'category.QUEJA_RECLAMO': 'Plainte ou réclamation',
  'form.request.categoryHelp.CONSULTA': 'Je veux poser une question, clarifier une situation ou demander des informations sur le Projet.',
  'form.request.categoryHelp.SUGERENCIA': 'Je veux partager une idée, une recommandation ou une proposition pour améliorer les activités du Projet.',
  'form.request.categoryHelp.PREOCUPACION': 'Je veux signaler une situation qui me préoccupe et que le Projet devrait connaître ou examiner.',
  'form.request.categoryHelp.QUEJA_RECLAMO': 'Je veux exprimer mon désaccord ou mon mécontentement à propos d’une situation, activité, décision ou d’un impact lié au Projet. Que s’est-il passé ? Quand ? Où ? Qui est concerné ?',
  'form.request.descTitle': 'Parlez-nous de votre demande',
  'form.request.descLabel.CONSULTA': 'Quelle information vous faut-il ou que souhaitez-vous clarifier ?',
  'form.request.descLabel.SUGERENCIA': 'Quelle proposition ou amélioration souhaitez-vous partager ?',
  'form.request.descLabel.PREOCUPACION': 'Quelle situation vous préoccupe ?',
  'form.request.descLabel.QUEJA_RECLAMO': 'Que s’est-il passé et quelle est votre préoccupation ?',
  'form.request.descHint.CONSULTA': 'Minimum 10 caractères. Dites-nous ce que vous voulez savoir ou quel aspect du Projet vous voulez clarifier.',
  'form.request.descHint.SUGERENCIA': 'Minimum 10 caractères. Décrivez votre idée ou proposition et en quoi elle pourrait aider.',
  'form.request.descHint.PREOCUPACION': 'Minimum 10 caractères. Décrivez la situation qui vous préoccupe, où elle s’est produite et pourquoi il est important de l’examiner.',
  'form.request.descHint.QUEJA_RECLAMO': 'Minimum 10 caractères. Dites-nous ce qui s’est passé, quand et où, et ce qui devrait être traité selon vous.',
  'form.request.expectation': 'Si vous le souhaitez, dites-nous ce que vous attendez du Projet pour traiter cette situation.',

  // Relationship with the project
  'relation.heading': 'Pour nous aider à comprendre votre demande (facultatif)',
  'relation.type': 'Quelle est votre relation avec le Projet ?',
  'relation.subtype': 'Précisez votre relation',
  'relation.other': 'Décrivez votre relation avec le Projet',
  'relation.type.PARTICIPANTE_COMUNIDAD': 'Participant ou communauté',
  'relation.type.ORGANIZACIONES_PROVEEDORES': 'Organisations et fournisseurs',
  'relation.type.INSTITUCIONES_OTROS': 'Institutions et autres acteurs',
  'relation.type.OTRO': 'Autre',
  'relation.type.NO_ESPECIFICA': 'Je préfère ne pas préciser',
  'relation.sub.PRODUCTOR_PARTICIPANTE': 'Producteur·rice participant(e)',
  'relation.sub.MIEMBRO_COMUNIDAD': 'Membre d’une communauté locale',
  'relation.sub.VECINO_AFECTADO': 'Voisin(e) ou personne potentiellement affectée',
  'relation.sub.ORG_SOCIA': 'Représentant(e) d’une organisation partenaire du projet',
  'relation.sub.ORG_LOCAL': 'Représentant(e) d’une organisation locale',
  'relation.sub.PROVEEDOR_CONTRATISTA': 'Fournisseur·se ou prestataire',
  'relation.sub.TRABAJADOR_PROYECTO': 'Employé(e) ou collaborateur·rice du Projet',
  'relation.sub.AUTORIDAD_PUBLICA': 'Autorité ou institution publique',
  'relation.sub.SOCIEDAD_CIVIL': 'Organisation de la société civile',
  'relation.sub.TITULAR_TIERRAS': 'Propriétaire ou titulaire de droits sur la terre',

  // Files
  'files.heading': 'Avez-vous une photo, un document ou une preuve à partager ?',
  'files.add': 'Joindre une photo ou un document',
  'files.hint': 'JPG, PNG ou PDF · {max} Mo maximum',

  // Location
  'form.location.heading': 'Où cela s’est-il produit ou à quel lieu se rapporte votre demande ?',
  'form.location.intro': 'Indiquez le lieu lié à votre demande. Vous pouvez choisir une communauté, une localité ou une zone du Projet.',
  'form.location.sector': 'Secteur, hameau ou communauté',
  'loc.region': 'Région de la zone du Projet',
  'loc.province': 'Province de la zone du Projet',
  'loc.district': 'District de la zone du Projet',
  'loc.otherRegion': 'Autre',

  // Review
  'form.review.heading': 'Vérifiez votre demande avant de l’envoyer',
  'form.review.anonymousBadge': 'Demande anonyme',
  'form.review.identifiedBadge': 'Demande avec coordonnées',
  'form.review.verify': 'Vérifiez que les informations sont correctes. Pour modifier quelque chose, vous pouvez revenir en arrière avant l’envoi.',
  'form.review.contactTitle': 'Vos coordonnées',
  'form.review.requestTitle': 'Votre demande',
  'form.review.type': 'Type',
  'form.review.description': 'Description',
  'form.review.location': 'Lieu lié à la demande',
  'form.review.files': 'Fichiers joints',
  'form.review.filesCount': '{n} fichier(s)',
  'form.review.noFiles': 'Aucun',
  'form.review.relation': 'Relation avec le Projet',
  'form.review.consentTitle': 'Traitement des données personnelles',
  'form.review.consentText': 'J’ai lu les informations sur l’utilisation et la protection de mes données personnelles.',
  'form.review.consentAnonymousText': 'Je confirme vouloir envoyer cette demande de manière anonyme.',
  'form.review.anonymousInfo': 'En envoyant une demande anonyme, vos coordonnées ne seront pas enregistrées. Nous ne pourrons donc ni vous contacter directement ni vous envoyer de réponse personnalisée.',
  'form.review.identifiedInfo': 'En fournissant vos coordonnées, nous pourrons vous contacter si nous avons besoin d’informations complémentaires et vous répondre.',
  'form.review.trackingInfo': 'Vous recevrez un code de suivi pour consulter l’état de votre demande.',
  'form.submit': 'Envoyer la demande',

  // Confirmation
  'success.heading': 'Votre demande a bien été reçue !',
  'success.thanks': 'Merci d’avoir contacté le Projet Jubilación Segura.',
  'success.keepCode': 'Conservez ce code en lieu sûr. Il vous sera nécessaire pour consulter l’état de votre demande.',
  'success.whatNow': 'Que pouvez-vous faire maintenant ?',
  'success.track': 'Consulter l’état de ma demande',
  'success.another': 'Enregistrer une autre demande',
  'success.uploadFailed': '{n} fichier(s) n’ont pas pu être envoyé(s). Vous pouvez réessayer de les joindre ici.',

  // Errors
  'error.contactRequired': 'Indiquez au moins un téléphone ou un e-mail.',
  'error.dateInFuture': 'La date ne peut pas être dans le futur.',
  'error.CONTACT_REQUIRED': 'Indiquez au moins un téléphone ou un e-mail.',
  'error.ID_DOCUMENT_INCOMPLETE': 'Indiquez le type et le numéro du document, ou aucun des deux.',
  'error.RELATION_OTHER_REQUIRED': 'Décrivez votre relation avec le Projet.',
  'error.RELATION_SUBTYPE_REQUIRED': 'Précisez votre relation avec le Projet.',
  'error.ORG_NOT_IN_PROJECT': 'Cette organisation n’appartient pas au projet sélectionné.',
  'error.DATE_IN_FUTURE': 'La date ne peut pas être dans le futur.',
  'error.RECEPTION_EVIDENCE_REQUIRED': 'Indiquez le type de preuve de réception.',
  'error.RECEPTION_RECORD_REQUIRED': 'Complétez le registre interne de réception.',
  'error.TEAM_REQUIRED': 'Indiquez au moins une personne de l’équipe technique du projet.',
  'error.REPORTER_NAME_REQUIRED': 'Indiquez le nom de la personne qui enregistre.',
  'error.OTHER_PLACE_REQUIRED': 'Précisez le lieu de l’événement.',
  'error.ORG_NOT_ALLOWED_FOR_EVENTS': 'Cette entité ne peut pas déclarer d’événements.',

  // Organisations, channels, places, proofs
  'org.FLOR_DE_CAFE': 'FLOR DE CAFE',
  'org.VALLE_VERDE': 'VALLE VERDE',
  'org.APROEXPORT': 'APROEXPORT',
  'org.APROCOYCE': 'APROCOYCE',
  'channel.ONLINE_FORM': 'Formulaire en ligne',
  'channel.MAILBOX': 'Boîtes physiques MACQR (organisations partenaires ou pépinières)',
  'channel.COMPLAINTS_BOOK': 'Livre de réclamations (organisations partenaires ou pépinières)',
  'channel.EMAIL': 'E-mail',
  'channel.WEBSITE': 'Site web',
  'channel.EVENT_BOX': 'Boîte MACQR lors d’événements',
  'channel.PAPER_FORM': 'Formulaire papier recueilli lors de visites techniques de terrain',
  'channel.PHONE_CALL': 'Appel téléphonique',
  'channel.IN_PERSON': 'Accueil en personne',
  'place.OFICINA_SOCIOS': 'Bureau des organisations partenaires',
  'place.OFICINA_VIVEROS': 'Bureau des pépinières',
  'place.COMUNIDAD': 'Communauté ou centre peuplé',
  'proof.FORMATO_MACQR': 'Formulaire papier MACQR (photo scannée)',
  'proof.CORREO_REGISTRO_WEB': 'Capture/PDF de l’e-mail ou du formulaire web reçu',
  'proof.LIBRO_ACTAS': 'Photo ou scan du livre de réclamations ou du compte rendu de réunion',
  'proof.CAPTURA_MENSAJE': 'Capture d’un message reçu (téléphone)',
  'proof.REGISTRO_INTERNO': 'Registre interne de réception',
  'proof.OTRO': 'Autre',

  // Internal form
  'internal.heading': 'Enregistrer une demande reçue par un autre canal',
  'internal.intro': 'Formulaire interne qui ajoute au système une question, suggestion, plainte ou réclamation reçue par le Projet par un autre canal.',
  'internal.section.origin': 'Données de réception',
  'internal.section.originHelp': 'Indiquez comment et quand la demande a été reçue par le Projet. Ces informations permettent de suivre son origine et son canal d’entrée.',
  'internal.who': 'Qui enregistre ?',
  'internal.registeredByName': 'Nom du membre du projet qui enregistre la demande',
  'internal.registeredByEmail': 'E-mail du membre du projet qui enregistre la demande',
  'internal.registeredByOrg': 'Organisation / équipe qui reçoit',
  'internal.how': 'Comment la demande est arrivée',
  'internal.channel': 'Canal d’entrée',
  'internal.receptionPlace': 'Lieu ou point de réception',
  'internal.presentedAt': 'Date de réception',
  'internal.presentedAtHint': 'Date à laquelle le Projet a reçu la demande pour la première fois.',
  'internal.registeredAt': 'Date d’enregistrement dans le système',
  'internal.automatic': 'Automatique',
  'internal.proof.heading': 'Preuve de réception',
  'internal.proof.question': 'Avez-vous un fichier qui prouve la réception ?',
  'internal.proof.yes': 'Oui → joindre le fichier (obligatoire)',
  'internal.proof.no': 'Non → compléter le registre interne de réception (obligatoire)',
  'internal.proof.kind': 'Type de preuve',
  'internal.proof.attachHelp': 'Joignez un fichier prouvant comment cette demande a été reçue.',
  'internal.proof.attach': 'Joindre la preuve',
  'internal.proof.formats': 'Photo, capture d’écran, PDF, document. Formats autorisés : JPG, PNG, PDF · Taille maximale : {max} Mo',
  'internal.proof.examples': 'Exemples : photo du formulaire papier MACQR reçu dans une boîte, un événement ou une visite technique ; capture d’un e-mail ou message reçu ; photo d’une page du livre de réclamations ou autre document attestant la réception.',
  'internal.proof.required': 'Joignez au moins un fichier prouvant la réception.',
  'internal.record.heading': 'Registre interne de réception',
  'internal.record.help': 'Complétez cette section lorsque la demande a été reçue verbalement ou qu’aucun document ne permet de prouver sa réception.',
  'internal.record.date': 'Date de réception',
  'internal.record.time': 'Heure de réception',
  'internal.record.medium': 'Moyen de réception',
  'internal.record.by': 'Personne qui a reçu la demande',
  'internal.record.role': 'Fonction',
  'internal.record.description': 'Comment la demande a-t-elle été reçue ?',
  'internal.record.descriptionHint': 'Décrivez brièvement comment la demande a été reçue, qui l’a présentée et dans quel contexte. Exemple : la personne a exprimé verbalement sa préoccupation lors d’une visite de l’équipe technique dans la communauté.',
  'internal.record.saved': 'Une fois enregistré, ce registre sera associé à la demande comme preuve de réception.',
  'internal.person.heading': 'Données de la personne à l’origine de la demande',
  'internal.person.question': 'La personne a-t-elle fourni ses coordonnées ?',
  'internal.person.yes': 'Oui, elle a laissé ses coordonnées',
  'internal.person.no': 'Non, la demande est anonyme',
  'internal.person.idNotice': 'Il n’est pas nécessaire de fournir la pièce d’identité pour présenter la demande.',
  'internal.relation.heading': 'Relation avec le projet',
  'internal.relation.question': 'Quelle est la relation de la personne avec le Projet ?',
  'internal.desc.heading': 'Description de la demande',
  'internal.desc.help': 'Retranscrivez ce que la personne a exprimé de la manière la plus claire et objective possible.',
  'internal.desc.label': 'Qu’a communiqué la personne ?',
  'internal.desc.hint': 'Minimum 10 caractères. Si vous les connaissez, indiquez ce qui s’est passé, quand et où. Si elle est connue, indiquez la solution attendue.',
  'internal.desc.files': 'Avez-vous une photo, un document ou une preuve que la personne a partagé avec sa demande ?',
  'internal.location.heading': 'Lieu lié à la demande',
  'internal.location.help': 'Il ne doit pas forcément correspondre au domicile de la personne : indiquez le lieu auquel se rapporte la demande.',
  'internal.consent': 'Je confirme que la personne a été informée du traitement de ses données personnelles et a donné son consentement sur le support physique (ou par le moyen par lequel elle a présenté sa demande).',
  'internal.submit': 'Enregistrer la demande',
  'internal.done.heading': 'Demande enregistrée avec succès !',
  'internal.done.text': 'La demande a été intégrée au Mécanisme de prise en charge du Projet.',
  'internal.done.evidence': 'Preuve de réception jointe',
  'internal.done.give': 'Remettez ce code à la personne. Il lui permettra de consulter ensuite l’état de sa demande.',
  'internal.done.important': 'Important : conservez ce code avec les informations de la demande. C’est l’identifiant qui permet le suivi.',
  'internal.done.anonymous': 'Si la demande est anonyme, ce code est le seul moyen de consulter son état.',
  'internal.done.view': 'Voir la demande enregistrée',
  'internal.done.another': 'Enregistrer une autre demande',

  // Entry pages of the two staff forms
  'entry.request.title': 'ENREGISTRER UNE DEMANDE REÇUE PAR UN AUTRE CANAL',
  'entry.request.intro': 'Ajoutez au système une question, suggestion, plainte ou réclamation reçue par le Projet par un autre canal.',
  'entry.request.new': 'Enregistrer une nouvelle demande',
  'entry.request.newHint': 'Saisissez les données de la demande reçue pour générer son code de suivi.',
  'entry.request.query': 'Consulter les demandes enregistrées',
  'entry.request.queryHint': 'Recherchez une demande par code, date ou état de traitement.',
  'entry.request.whatTitle': 'Quelles demandes devez-vous enregistrer ?',
  'entry.request.whatText': 'Toutes les questions, suggestions, préoccupations, plaintes ou réclamations liées au Projet reçues par d’autres canaux, par exemple : boîtes physiques, livres de réclamations, accueil en personne (visites techniques ou événements), e-mail, site web, téléphone ou autres moyens autorisés.',
  'entry.event.title': 'ENREGISTRER UN ÉVÉNEMENT',
  'entry.event.intro': 'N’ajoutez au système que des événements terminés. Ayez sous la main la liste de présence scannée, 3 photos maximum et, le cas échéant, le compte rendu, la vidéo ou tout autre moyen de vérification.',
  'entry.event.new': 'Enregistrer un événement',
  'entry.event.newHint': 'Saisissez les données de l’événement terminé.',
  'entry.event.query': 'Consulter les événements enregistrés',
  'entry.event.queryHint': 'Recherchez par organisation et date de l’événement.',

  // Events
  'component.DISTRIBUCION_CARBONO': 'Distribution des bénéfices du carbone',
  'component.MACQR': 'Mécanisme de prise en charge (MACQR)',
  'technical.REUNION_TECNICA': 'Réunion technique mensuelle',
  'fev.intro': 'N’ajoutez au système que des événements terminés. Ayez sous la main la liste de présence scannée, 3 photos maximum et, le cas échéant, le compte rendu, la vidéo ou tout autre moyen de vérification.',
  'fev.who': 'Qui enregistre ?',
  'fev.reportedByName': 'Nom du membre du projet qui enregistre l’événement',
  'fev.reportedByEmail': 'E-mail du membre du projet qui enregistre l’événement',
  'fev.contractWave': 'Contrat ou vague liée à l’événement',
  'fev.teamHelp': 'Remplissez au moins un champ : membres de l’équipe technique du projet (toutes entités) ayant participé à l’événement. Ils sont déjà inclus dans le total des participants.',
  'fev.attachments.beforeRegister': 'Les moyens de vérification doivent être joints avant d’enregistrer l’événement. La liste de présence est obligatoire ; ajoutez des photos (3 maximum) et, le cas échéant, compte rendu, vidéo ou autres documents.',
  'fev.attachments.attendanceRequired': 'Joignez au moins la liste de présence scannée.',
};
